import { gql } from '@apollo/client';

export default gql`
  mutation RemoveCompetitionSeasonPriority($competitionSeasonId: Int) {
    removeCompetitionSeasonPriority(competitionSeasonId: $competitionSeasonId) {
      id
    }
  }
`;
